const Contact = () => {
  return <>Contacts Page</>;
};

export default Contact;
